// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ngw-pyramid-menu-icon {
  display: flex;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  border-radius: 2px;
  width: 24px;
  height: 24px;
  color: var(--primary);
  line-height: 24px;
  text-align: center;
}
.ngw-pyramid-menu-icon > svg.icon {
  color: inherit;
  font-size: 24px;
}
.ngw-pyramid-menu-icon > span.main {
  color: inherit;
  line-height: 34px;
}
.ngw-pyramid-menu-icon > span.more {
  display: block;
  position: absolute;
  top: -6px;
  right: -2px;
  height: 16px;
}
.ngw-pyramid-menu-icon > span.more > svg.icon {
  font-size: 16px;
  line-height: 1;
}
.ngw-pyramid-menu-icon > span.more-success {
  color: var(--success);
}
.ngw-pyramid-menu-icon > span.more-danger {
  color: var(--danger);
}
.ngw-pyramid-menu-drawer .ant-drawer-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  height: 40px;
  padding: 11px 5px;
}
.ngw-pyramid-menu-drawer .ant-drawer-header .ant-drawer-header-title .ant-drawer-close {
  margin-left: auto;
  margin-right: 0;
}
.ngw-pyramid-menu-drawer .ant-drawer-body {
  padding: 0px;
}
.ngw-pyramid-menu-drawer .ant-drawer-body a {
  display: block;
  padding: 12px 24px;
  color: var(--text-base);
  line-height: 1.25;
  text-decoration: none;
}
.ngw-pyramid-menu-drawer .ant-drawer-body a:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.ngw-pyramid-menu-drawer .ant-drawer-body a.notification-success {
  background-color: var(--surface-bg-success);
}
.ngw-pyramid-menu-drawer .ant-drawer-body a.notification-danger {
  background-color: var(--surface-bg-danger);
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/pyramid/nodepkg/layout/Menu.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;AACJ;AAXA;EAaQ,cAAA;EACA,eAAA;AACR;AAfA;EAkBQ,cAAA;EACA,iBAAA;AAAR;AAnBA;EAuBQ,cAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AADR;AA1BA;EA8BY,eAAA;EACA,cAAA;AADZ;AAIQ;EACI,qBAAA;AAFZ;AAKQ;EACI,oBAAA;AAHZ;AAQA;EAEQ,4CAAA;EACA,YAAA;EACA,iBAAA;AAPR;AAGA;EAOY,iBAAA;EACA,eAAA;AAPZ;AADA;EAaQ,YAAA;AATR;AAJA;EAgBY,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,qBAAA;AATZ;AAWY;EACI,qCAAA;AAThB;AAYY;EACI,2CAAA;AAVhB;AAaY;EACI,0CAAA;AAXhB","sourcesContent":[".ngw-pyramid-menu-icon {\n    display: flex;\n    position: relative;\n    vertical-align: middle;\n    cursor: pointer;\n    border-radius: 2px;\n    width: 24px;\n    height: 24px;\n    color: var(--primary);\n    line-height: 24px;\n    text-align: center;\n\n    > svg.icon {\n        color: inherit;\n        font-size: 24px;\n    }\n\n    > span.main {\n        color: inherit;\n        line-height: 34px;\n    }\n\n    > span.more {\n        display: block;\n        position: absolute;\n        top: -6px;\n        right: -2px;\n        height: 16px;\n\n        > svg.icon {\n            font-size: 16px;\n            line-height: 1;\n        }\n\n        &-success {\n            color: var(--success);\n        }\n\n        &-danger {\n            color: var(--danger);\n        }\n    }\n}\n\n.ngw-pyramid-menu-drawer {\n    .ant-drawer-header {\n        border-bottom: 1px solid rgba(0, 0, 0, 0.04);\n        height: 40px;\n        padding: 11px 5px;\n\n        .ant-drawer-header-title .ant-drawer-close {\n            margin-left: auto;\n            margin-right: 0;\n        }\n    }\n\n    .ant-drawer-body {\n        padding: 0px;\n\n        a {\n            display: block;\n            padding: 12px 24px;\n            color: var(--text-base);\n            line-height: 1.25;\n            text-decoration: none;\n\n            &:hover {\n                background-color: rgba(0, 0, 0, 0.04);\n            }\n\n            &.notification-success {\n                background-color: var(--surface-bg-success);\n            }\n\n            &.notification-danger {\n                background-color: var(--surface-bg-danger);\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
